import { useTranslation } from "react-i18next";
import { dirFor, normalizeLanguage, type Dir } from "@/lib/languages";

/** Text direction of the active UI language ("rtl" for he/ar, else "ltr"). */
export function useDir(): Dir {
  const { i18n } = useTranslation();
  return dirFor(normalizeLanguage(i18n.resolvedLanguage ?? i18n.language));
}

/** Active language code, always one of the 20 supported ones. */
export function useLang(): string {
  const { i18n } = useTranslation();
  return normalizeLanguage(i18n.resolvedLanguage ?? i18n.language);
}
